import {SectionFragment} from '../graphql/generated/types';
import {initializeFetchStatus} from './initializeFetchStatus.function';
import {initializeGroupState} from './initializeGroupState.function';
import {initializeParentRelation} from './initializeParentRelation.function';
import {PagewebLayoutState} from './PagewebLayoutState.interface';

/**
 * 주의 : mutable. immer 가 적용된 경우만 사용해야함
 */
export function initializeSectionState({
  state,
  id,
  parentId,
  section,
  error,
}: {
  state: PagewebLayoutState;
  id: string;
  /**
   * layoutId
   */
  parentId: string;
  section?: SectionFragment;
  error?: Error;
}) {
  const isEnoughData = !!section;
  initializeFetchStatus({
    state,
    id,
    isEnoughData,
    error,
  });
  if (!isEnoughData) {
    return;
  }

  if (
    !state.relations.layouts[parentId].childrenIds.find(
      childrenId => childrenId === id
    )
  ) {
    state.relations.layouts[parentId].childrenIds.push(id);
  }

  const {groups, ...entity} = section;
  state.entities.sections[id] = entity;

  initializeParentRelation({
    state,
    relationKey: 'sections',
    id,
    parentId,
  });
  groups?.forEach(group => {
    initializeGroupState({
      state,
      parentId: id,
      id: group.id,
      group,
      isNestedGroup: false,
    });
  });
}
